export const DEPARTMENT_SELECT = "departmentSelect";
export const SECTION_SELECT = "sectionSelect";
export const ROLE_SELECT = "roleSelect";

export const SEARCH_INPUT = "searchInput";

export const USER_LIST_SECTION = "userList";

export const ACCOR_BUTTON = "accordianButton";
export const SEARCH_BUTTON = "searchButton";
export const LOAD_MORE_BUTTON = "loadMoreButton";
export const SORT_SELECT = "sortSelect";

export const TOTAL_USERS = "totalUsers";
export const HEADER_CONTENT = "headerContent";